import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Dropdown } from 'react-toolbox';
import S from '../TemplateStyling.scss';
import parseMeasurement from './measures/measurementParsing';

const archOrTransomTypes = [
  { value: 'Arch', label: 'Arch' },
  { value: 'Transom', label: 'Transom' },
];

function ArchesTransoms({
  arches_transoms_measures, onChange, openingCount, openingTypeLabel,
}) {
  const handleFieldChange = (idx, field, value) => {
    const updated = arches_transoms_measures.map((m, i) =>
      (i === idx ? { ...m, [field]: value } : m),
    );
    onChange(updated);
  };

  const handleNestedChange = (idx, group, subfield, value) => {
    const updated = arches_transoms_measures.map((m, i) => {
      if (i === idx) {
        return { ...m, [group]: { ...m[group], [subfield]: value } };
      }
      return m;
    });
    onChange(updated);
  };

  const addRow = () => {
    onChange([
      ...arches_transoms_measures,
      {
        openingNumber: '',
        archOrTransom: '',
        unitSize: { width: '', height: '' },
        roughOpening: { width: '', height: '' },
        legHeight: '',
      },
    ]);
  };

  const removeRow = (idx) => {
    onChange(arches_transoms_measures.filter((_, i) => i !== idx));
  };

  return (
    <div>
      <h6>Arches/Transoms Measured</h6>
      {arches_transoms_measures.map((measure, idx) => (
        <div key={measure.openingNumber || `archTransom-${idx}`} style={{ border: '1px solid #eee', marginBottom: 10, padding: 10 }}>
          <div className={S.container}>
            <strong>ALL MEASURES MUST BE IN INCHES</strong>
            <strong>Opening #{idx + 1}</strong>
          </div>
          <Input label="Opening #" hint={`1-${openingCount}, matching a measured ${openingTypeLabel}`} value={measure.openingNumber} onChange={v => handleFieldChange(idx, 'openingNumber', v)} />
          <Dropdown label="Arch or Transom" source={archOrTransomTypes} value={measure.archOrTransom} onChange={v => handleFieldChange(idx, 'archOrTransom', v)} />
          <strong>UNIT SIZE</strong>
          <Input label="Width" hint="e.g. 34 1/2" value={measure.unitSize.width} onChange={v => handleNestedChange(idx, 'unitSize', 'width', v)} />
          <Input label="Height" hint="e.g. 34 1/2" value={measure.unitSize.height} onChange={v => handleNestedChange(idx, 'unitSize', 'height', v)} />
          <strong>ROUGH OPENING</strong>
          <Input label="Width" hint="e.g. 34 1/2" value={measure.roughOpening.width} onChange={v => handleNestedChange(idx, 'roughOpening', 'width', v)} />
          <Input label="Height" hint="e.g. 34 1/2" value={measure.roughOpening.height} onChange={v => handleNestedChange(idx, 'roughOpening', 'height', v)} />
          <strong>LEG HEIGHT</strong>
          <Input label="Height" hint="e.g. 34 1/2" value={measure.legHeight} onChange={v => handleFieldChange(idx, 'legHeight', v)} />
          <Button className={S.removeButton} label="Remove" onClick={() => removeRow(idx)} />
        </div>
      ))}
      <Button className={S.button} label="Add Arch/Transom" onClick={addRow} />
    </div>
  );
}

ArchesTransoms.propTypes = {
  arches_transoms_measures: PropTypes.arrayOf(
    PropTypes.shape({
      openingNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      archOrTransom: PropTypes.string,
      unitSize: PropTypes.shape({
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      roughOpening: PropTypes.shape({
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      legHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  onChange: PropTypes.func.isRequired,
  openingCount: PropTypes.number.isRequired,
  openingTypeLabel: PropTypes.string.isRequired,
};

export default ArchesTransoms;

export function validateArchesTransoms(arches_transoms_measures, openingCount, openingTypeLabel) {
  const errors = {};
  arches_transoms_measures.forEach((item, idx) => {
    if (!item.archOrTransom) {
      if (!errors[idx]) errors[idx] = {};
      errors[idx].archOrTransom = ['Arch or Transom is required.'];
    }
    const openingNumber = Number(item.openingNumber);
    if (
      item.openingNumber === undefined
      || item.openingNumber === ''
      || !Number.isInteger(openingNumber)
      || openingNumber < 1
      || openingNumber > openingCount
    ) {
      if (!errors[idx]) errors[idx] = {};
      errors[idx].openingNumber = [
        `Opening # must be a number between 1 and ${openingCount}, matching a measured ${openingTypeLabel}.`,
      ];
    }
    const measurementFields = [
      'legHeight',
    ];
    measurementFields.forEach((field) => {
      const value = item[field];
      if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [`${field} must be a number or fraction.`];
      }
    });
    if (item.unitSize) {
      ['width', 'height'].forEach((subfield) => {
        const value = item.unitSize[subfield];
        if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx][`unitSize.${subfield}`] = [`unitSize.${subfield} must be a number or fraction.`];
        }
      });
    }
    if (item.roughOpening) {
      ['width', 'height'].forEach((subfield) => {
        const value = item.roughOpening[subfield];
        if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx][`roughOpening.${subfield}`] = [`roughOpening.${subfield} must be a number or fraction.`];
        }
      });
    }
  });
  if (Object.keys(errors).length > 0) {
    errors.archesTransoms = [
      'Please ensure all numeric fields are valid numbers.',
    ];
  }
  return errors;
}



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/ArchesTransoms.jsx